import * as React from "react";

const UserContext = React.createContext({
  email: "contact@juliamoore.me",
  name: "Julia Moore",
});

export default UserContext;
